/* src/consent.svelte generated by Svelte v4.1.1 */
import {
	SvelteComponent,
	append,
	detach,
	element,
	empty,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_custom_element_data,
	space
} from "svelte/internal";

import "svelte/internal/disclose-version";
import { onDestroy, getContext } from 'svelte';
import { defaultContextId } from "core";

function create_if_block(ctx) {
	let cookies_panel;
	let cookies_p;
	let t1;
	let cookies_button;
	let mounted;
	let dispose;

	return {
		c() {
			cookies_panel = element("cookies-panel");
			cookies_p = element("cookies-p");
			cookies_p.textContent = "Les images utilisées dans ces énigmes proviennent de sites web externes.\n\t\t\tLeur sécurité, confidentialité et moralité ne pouvant être vérifiées, il\n\t\t\test recommandé de faire preuve d'autant de vigilance lors de l'ouverture\n\t\t\td'une enigme que lorsque vous ouvrez n'importe quel lien.";
			t1 = space();
			cookies_button = element("cookies-button");
			cookies_button.textContent = "Je fais confiance aux personnes qui partagent des énigmes.";
			set_custom_element_data(cookies_button, "aria-label", "consent-button");
			set_custom_element_data(cookies_panel, "panel-title", "Avertissement");
			set_custom_element_data(cookies_panel, "data-testid", /*dataTestid*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, cookies_panel, anchor);
			append(cookies_panel, cookies_p);
			append(cookies_panel, t1);
			append(cookies_panel, cookies_button);

			if (!mounted) {
				dispose = listen(cookies_button, "click", /*click_handler*/ ctx[5]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*dataTestid*/ 1) {
				set_custom_element_data(cookies_panel, "data-testid", /*dataTestid*/ ctx[0]);
			}
		},
		d(detaching) {
			if (detaching) {
				detach(cookies_panel);
			}

			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let if_block = /*puzzle*/ ctx[1] && !/*consent*/ ctx[2] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (/*puzzle*/ ctx[1] && !/*consent*/ ctx[2]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) {
				detach(if_block_anchor);
			}

			if (if_block) if_block.d(detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { dataTestid = undefined } = $$props;
	let { contextId = defaultContextId } = $$props;
	const context = getContext(contextId);
	let puzzle = null;
	let consent = context.consentStorage.read();
	const sub = context.puzzleStorage.watch().subscribe(value => $$invalidate(1, puzzle = value), console.error);
	context.puzzleStorage.read().then(value => $$invalidate(1, puzzle = value)).catch(console.error);
	const sub2 = context.consentStorage.watch().subscribe(value => $$invalidate(2, consent = value), console.error);
	onDestroy(() => sub.unsubscribe());
	onDestroy(() => sub2.unsubscribe());
	const click_handler = () => context.consentStorage.save(true);

	$$self.$$set = $$props => {
		if ('dataTestid' in $$props) $$invalidate(0, dataTestid = $$props.dataTestid);
		if ('contextId' in $$props) $$invalidate(4, contextId = $$props.contextId);
	};

	return [dataTestid, puzzle, consent, context, contextId, click_handler];
}

class Consent extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { dataTestid: 0, contextId: 4 });
	}
}

export default Consent;